// Sections that are built but switched off for now. Set a flag to true to bring the section back (its menu link and
// its pages); nothing has been removed.

// Integration (System Management > Integration, and the integration action pages).
export const SHOW_INTEGRATION = false;
